<template>
  <div class="dashboard-customer-project--hd">
    <div class="d_p_n">
      {{ constants.PROJECTS_TEXT }}
    </div>
    <div class="d_p_l">
      {{ constants.PROJECTS_LEAD_TEXT }}
    </div>
    <div class="d_a_l">
      {{ constants.ACTION_TEXT }}
    </div>
  </div>
  <div class="dashboard-customer-project--content">
    <div class="customer-project--list" v-for="project in displayedProjects" :key="project.id">
      <div class="d_p_n">
        <div class="d_p_b">
          <div class="d_p_img">
            <img
              :src="project.avatarUrls['48x48']"
              alt=""
            />
          </div>
          <div class="d_p_name">
            <router-link id="detailLink" :to="`/employee/project-detail/${project.key}`">
              {{ project.name }}
            </router-link>
          </div>
        </div>
      </div>
      <div class="d_p_l">
        <div class="p_l_b">
          <div class="p_l_img">
            <img
              :src="project.lead.avatarUrls['48x48']"
              alt=""
            />
          </div>
          <div class="p_l_name">{{ project.lead.displayName }}</div>
        </div>
      </div>

      <div class="d_a_l">
        <ul>
          <li>
            <router-link :to="`/employee/project-detail/${project.key}`" id="detailLink">
              {{ constants.DETAIL_LINK }}
            </router-link>
          </li>
          <!-- <li>
            <router-link :to="'/employee/dashboard'" id="chatLink">
              {{ constants.CHAT_LINK }}
            </router-link>
          </li>
          <li>
            <router-link :to="'/employee/dashboard'" id="filesLink">
              {{ constants.FILES_LINK }}
            </router-link>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="v1-load-more" v-if="showLoadMore">
      <button class="v1-button-outline" id="projectLoadMoreBtn" @click="loadMoreProjects">
        {{ constants.LOAD_MORE_BUTTON }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";
import axios from "axios";
import { API_BASE_URL } from "@/config/api.config";

interface Project {
  id: string;
  key: string;
  name: string;
  lead: {
    displayName: string;
    avatarUrls: {
      [key: string]: string;
    };
  };
  avatarUrls: {
    [key: string]: string;
  };
}

export default defineComponent({
  name: "ProjectsList",
  data() {
    return {
      constants,
      projects: [] as Project[],
      displayedCount: 2,
    };
  },
  mounted() {
    this.getProjects();
  },
  computed: {
    displayedProjects(): Project[] {
      return this.projects.slice(0, this.displayedCount);
    },
    showLoadMore(): boolean {
      return this.displayedCount < this.projects.length;
    }
  },
  methods: {
    async getProjects() {
      const username = localStorage.getItem("jira_user_username");
      try {
        const response = await axios.get(`${API_BASE_URL}/jira/projects/${username}/`);
        this.projects = response.data.projects;
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    },
    loadMoreProjects() {
      this.displayedCount = this.projects.length;
    },
  },
});
</script>
